// extracted by mini-css-extract-plugin
export default {"pageHeader":"ToDos_pageHeader__0Fdrh","container":"ToDos_container__nheHo"};